export default ({request}) => ({
  shipmentDashboardSumDataApi(data = {}) {
    return request({
      url: '/factory/shipment/dashboard/sumData',
      method: 'post',
      data,
    })
  },
  shipmentDashboardCustListApi(data = {}) {
    return request({
      url: '/factory/shipment/dashboard/cust/list',
      method: 'post',
      data,
    })
  },
  shipmentDashboardFactoryListApi(data = {}) {
    return request({
      url: '/factory/shipment/dashboard/factory/list',
      method: 'post',
      data,
    })
  },
  shipmentDashboardSalesPersonListApi(data = {}) {
    return request({
      url: '/factory/shipment/dashboard/salesPerson/list',
      method: 'post',
      data,
    })
  },
})
